import { useSelector } from "react-redux"
import { Navigate, useLocation } from "react-router-dom"
import { getTokenLocal } from "../../../helper/utils"
import { useState } from "react"
import PermsWrapper from "../Auth/PermsWrapper"
import { useIdleTimer } from "react-idle-timer"
import IdleAlert from "../Modal/IdleAlert"

type ProtectedRouteProps = {
  permission: any,
  children: any
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { permission, children } = props

  const token = getTokenLocal()
  const [open, setOpen] = useState<boolean>(false);


  const onIdle = () => {
    setOpen(true);
  }

  useIdleTimer({
    onIdle,
    timeout: 1200000,
    throttle: 0
  })

  const appData: any = useSelector((state: any) => {
    return state.app
  })

  let location = useLocation()

  if (!appData.isAdminLoggedIn && !token) {
    return <Navigate to="/auth" state={{ from: location }} replace />
  }

  return (
    <>
      <PermsWrapper perm={permission} isProtected={true}>
        {children}
      </PermsWrapper>
      <IdleAlert open={open} setOpen={setOpen} />
    </>
  )
}

export default ProtectedRoute
